import React from 'react';
import CRUDManager from '../../../../shared/components/crud/CRUDManager';
import { centerConfig } from '../config/centerConfig';

export default function Centers() {
  return <CRUDManager config={centerConfig} />;
}